import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=81edf510&scoped=true&"
import script from "./ProfileMenu.vue?vue&type=script&lang=ts&"
export * from "./ProfileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=81edf510&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81edf510",
  null
  
)

export default component.exports